import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { XCircle, Loader2 } from "lucide-react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const NAVY = "#1E2761";
const ICE = "#CADCFC";

export default function PaymentCancelPage() {
  const [params] = useSearchParams();
  const regId = params.get("registration_id");
  const [removing, setRemoving] = useState(true);

  useEffect(() => {
    if (!regId) { setRemoving(false); return; }
    // Auto-delete the abandoned registration so it does not appear anywhere
    axios.delete(`${API}/barcelona/registration/${regId}`)
      .catch(() => {})
      .finally(() => setRemoving(false));
  }, [regId]);

  return (
    <div className="min-h-[80vh] flex items-center justify-center" style={{ backgroundColor: ICE }} data-testid="payment-cancel">
      <div className="max-w-md text-center px-6 py-16 bg-white border" style={{ borderColor: `${NAVY}22` }}>
        {removing ? (
          <>
            <Loader2 className="h-10 w-10 mx-auto mb-6 animate-spin" style={{ color: NAVY }} />
            <h1 className="font-serif text-2xl" style={{ color: NAVY }}>Cancelling...</h1>
          </>
        ) : (
          <>
            <XCircle className="h-12 w-12 mx-auto mb-6 text-gray-500" strokeWidth={1.5} />
            <h1 className="font-serif text-2xl mb-3" style={{ color: NAVY }}>Payment Cancelled</h1>
            <p className="text-gray-700 mb-8">
              No charge was made. You may register again anytime.
            </p>
            <Link to="/register" className="inline-block px-8 py-3 text-xs tracking-[0.2em] uppercase text-white" style={{ backgroundColor: NAVY }} data-testid="retry-btn">
              Register Again
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
